import { ReactNode } from 'react';

import { Link as BaseLink } from '@braskai/ui-kit';

type LinkProps = {
  children: ReactNode;
  src: string;
};

export const Link = ({ children, src }: LinkProps) => (
  <BaseLink href={src} target="_blank">
    {children}
  </BaseLink>
);
